import React, { useState, useEffect } from "react";
import "./NidhiPage.css";
import BASE_URL from "../apiConfig";
import useRecaptcha from "../hooks/useRecaptcha";
import technopark from "../images/technopark.jpg";

function NidhiPage() {

    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const [widgetId, setWidgetId] = useState(null);
    const { getResponse } = useRecaptcha();

    useEffect(() => {
        if (window.grecaptcha) {
            const container = document.getElementById("recaptcha-nidhi");
            if (container && container.innerHTML === "") {
                try {
                    const id = window.grecaptcha.render(container, {
                        // sitekey: "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI",
                         sitekey: window.RECAPTCHA_SITE_KEY,
                    });
                    setWidgetId(id);
                } catch (err) {
                    console.error("reCAPTCHA NidhiPage render error:", err);
                }
            }
        }
    }, []);

    const [formData, setFormData] = useState({
        full_name: "",
        phone: "",
        email: "",
        organization: "",
        challenges: ""
    });

    const handleChange = e => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.full_name || !formData.phone) {
            setMessage("❌ Name & Phone required");
            return;
        }

        setLoading(true);

        try {
            const token = getResponse(widgetId);
            if (!token) {
                setMessage("❌ Please complete the reCAPTCHA");
                setLoading(false);
                return;
            }
            const fd = new FormData();
            Object.keys(formData).forEach(k => fd.append(k, formData[k]));
            fd.append("_type", "nidhi_demo");
            fd.append("tk", token);

            const res = await fetch(BASE_URL + "/DemoApi/saveData", {
                method: "POST",
                body: fd
            });

            const result = await res.json();

            if (result.status) {
                setMessage("✅ Demo Request Submitted");
                setFormData({
                    full_name: "",
                    phone: "",
                    email: "",
                    organization: "",
                    challenges: ""
                });
            } else {
                setMessage("❌ " + (result.message || "Verification Failed"));
            }

        } catch (err) {
            console.error("Submission Error:", err);
            setMessage("❌ Submission Failed. Check Console.");
        }

        setLoading(false);
    };

    return (
        <>

            {/* ===== HERO (UNCHANGED STYLE) ===== */}
            <div
                className="bg-container-nidhi"
                style={{ backgroundImage: `url(${technopark})` }}
            ></div>

            <div className="nidhi-wrapper">

                <div className="nidhi-left">
                    <h1>IGNOSI - ALCHEMY</h1>
                    <h2>Complete Digital Nidhi Banking Platform</h2>

                    <p>
                        Powerful FINTECH software designed for Nidhi
                        companies managing deposits, loans,
                        share capital and compliance operations.
                    </p>

                    <ul>
                        <li>KYC & Membership Automation</li>
                        <li>Loan & Deposit Management</li>
                        <li>Automated Accounting</li>
                        <li>Cloud Enabled Operations</li>
                    </ul>
                </div>

                <div className="nidhi-right">

                    <form className="demo-form-nidhi"
                        onSubmit={handleSubmit}>

                        <input name="full_name"
                            placeholder="Full Name*"
                            value={formData.full_name}
                            onChange={handleChange} />

                        <input name="phone"
                            placeholder="Phone Number*"
                            value={formData.phone}
                            onChange={handleChange} />

                        <input name="email"
                            placeholder="Email Address" />

                        <input name="organization"
                            placeholder="Company Name" />

                        <textarea name="challenges"
                            placeholder="Your Requirement" />

                        <div
                            id="recaptcha-nidhi"
                            style={{ marginBottom: "15px" }}
                        ></div>

                        <button>
                            {loading ? "Submitting..." : "Book a Demo"}
                        </button>

                        {message && <p className="form-msg-nidhi">{message}</p>}

                    </form>

                </div>
            </div>


            {/* ===== FINTECH INTRO ===== */}
            <section className="nidhi-intro">
                <h2>What is NIDHI Software?</h2>
                <p>
                    ALCHEMY Nidhi Software is a specialized FINTECH
                    solution covering KYC compliance, share
                    management, loan schemes, deposits and
                    day-to-day transaction automation with
                    mobile-enabled operations.
                </p>
            </section>


            {/* ===== WHY ALCHEMY ===== */}
            <section className="nidhi-why">

                <h2>Why ALCHEMY Software?</h2>

                <div className="why-grid">

                    {[
                        "User Responsive Platform",
                        "Top-Up Enabled Software",
                        "Full Features from Base Package",
                        "FINTECH Industry Experts",
                        "Affordable Software",
                        "Paperless Applications"
                    ].map((item, i) => (
                        <div key={i} className="why-card">
                            <h3>{item}</h3>
                        </div>
                    ))}

                </div>

            </section>


            {/* ===== FEATURES GRID ===== */}
            <section className="nidhi-features">

                <h2>Alchemy Nidhi Software Features</h2>

                <div className="feature-grid">

                    {[
                        "Automated KYC & Membership",
                        "Auto FD / RD / Loan Forms",
                        "Share Management",
                        "NDH-3 Reports",
                        "Due Reminder Alerts",
                        "Mobile Passbook",
                        "HR Management",
                        "Auto SMS Facility",
                        "Cloud Security",
                        "Corporate Accounting"
                    ].map((f, i) => (
                        <div key={i} className="feature-card">
                            <p>{f}</p>
                        </div>
                    ))}

                </div>

            </section>


            {/* ===== ACCOUNTING ===== */}
            <section className="nidhi-account">

                <h2>Advanced Accounting Engine</h2>

                <p>
                    Complete accounting automation including
                    Day Book, Ledger, Trial Balance,
                    Profit & Loss Account and Balance Sheet
                    generation with Excel, PDF and CSV exports.
                </p>

            </section>

        </>
    );
}

export default NidhiPage;